import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function DonutsPage() {

    const heroData = [
        {
          title: "Artisans",
          content: "Our artisanal baked goods are handcrafted with love and care, using traditional techniques and premium ingredients. From rustic loaves to decadent pastries, each item is a testament to the art of baking, delivering exceptional taste and quality.",
          image: images.ArtisansHeroImage, 
        },
      ];

    const productData = [
      {
        name: "Artisans opt 1",
        image: [
          images.Artisan1,
        ]
      },
      {
        name: "Artisans opt 2",
        image: [
          images.Artisan2,
        ]
      },
      {
        name: "Artisans opt 3",
        image: [
          images.Artisan3,
        ]
      },
      {
        name: "Artisans opt 4",
        image: [
          images.Artisan4,
        ]
      },
      {
        name: "Artisans opt 5",
        image: [
          images.Artisan5,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Artisans opt 3",
        image1: [
          images.Artisan3,
        ],
        content1: "",
        name2: "Artisans opt 5",
        image2: [
          images.Artisan5,
        ],
        content2: ""
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
